import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PASSWORD_RULES, PasswordRule } from '../../../shared/constants/password-rules.constants';

@Component({
  selector: 'app-password-validation-indicators',
  templateUrl: './password-validation-indicators.component.html',
  styleUrls: ['./password-validation-indicators.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PasswordValidationIndicatorsComponent {
  @Input() passwordControl: AbstractControl;

  passwordRules: PasswordRule[] = PASSWORD_RULES;

  get isTyping(): boolean {
    return !!this.passwordControl?.value;
  }

  get isTouched(): boolean {
    return !!this.passwordControl?.touched;
  }

  isSatisfied(key: string): boolean {
    if (!this.passwordControl?.value) return false;
    return !this.passwordControl.hasError(key);
  }

  getIconClass(key: string): string {
    if (!this.isTyping) return 'pi-info-circle default';
    if (this.isSatisfied(key)) return 'pi-check-circle satisfied';
    // Not satisfied: show red only if touched (blur), otherwise neutral
    if (this.isTouched) return 'pi-times-circle not-satisfied';
    return 'pi-info-circle default';
  }

  getTextClass(key: string): string {
    if (!this.isTyping) return '';
    if (this.isSatisfied(key)) return 'satisfied';
    // Not satisfied: show red only if touched (blur), otherwise neutral
    if (this.isTouched) return 'not-satisfied';
    return '';
  }
}
